export default __webpack_public_path__ + "static/media/a024-8.be91cbe2.svg";